export default "__VITE_ASSET__2WsxMNkI__"